<script setup>
</script>

<template>
  <button>
    <slot />
  </button>
</template>
